import Vue from 'vue'
import GlobalMixin from '~/mixins/global-mixin'
import SeoHeadMixin from '~/mixins/seo-head'

Vue.mixin(GlobalMixin)
Vue.mixin(SeoHeadMixin)
